define('shared/util/checkout/checkout',[
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/util/state',
    'shared/initializer/form/constants',
    'shared/remote/order/get',
    'shared/remote/member/cache',
    'shared/util/state/adapters/pending',
    'shared/util/state/adapters/order',
    'shared/page/apiVersion'
],
function (
    RSVP, 
    console, 
    state, 
    constants, 
    getOrder, 
    memberCache, 
    pendingAdapter,
    orderAdapter,
    getAPIVersion
) {
    'use strict';
    var LOG_TITLE = 'shared/util/checkout:';

    return {
        handlePaymentSucceeded: function (orderId) {
            var offerId, orderInfo, events, apiVersion;

            return RSVP.resolve()
                .then(function(){
                    return getAPIVersion();
                })
                .then(function(value){
                    apiVersion = value;
                    return state.adapters.add(orderAdapter);
                })
                // get order info from server side
                .then(function(){
                    if (apiVersion === 'old-house') {
                        return getOrder({
                            id: orderId,
                            cache: {
                                bypass: true
                            }
                        });
                    }
                    else {
                        return state.retrieve('order'); 
                    }
                })
                .then(function(oi){
                    orderInfo = oi;
                }, function(reason){
                    console.log(LOG_TITLE, 'Get order failed');
                    return RSVP.reject(reason);
                })
                // verify the order status is correct
                .then(function(){
                    if (orderInfo.Status && orderInfo.Status.toLowerCase() === 'ordered') {
                        return RSVP.resolve();
                    }
                    else {
                        var err = new Error(
                            'Order status is incorrect, please contact us and refer order id: ' + 
                            orderId);
                        err.orderId = orderId;
                        err.type = 'payment';
                        return RSVP.reject(err);
                    }
                })
                // get pending events
                .then(function(){
                    return state.adapters.add(pendingAdapter);
                })
                .then(function(){
                    return state.get(constants.State.TrackingPendingEvents);
                })
                .then(function (values) {
                    events = values[0] || [];
                })
                // push events into tracking events array
                .then(function(){
                    return new RSVP.Promise(function (resolve, reject) {
                        var promises = [];

                        if (apiVersion === 'old-house') {
                            promises.push(
                                state.push('order.order_id', orderId)
                            );
                        }

                        events.push(constants.EVENT.ORDER_CREATION);
                        promises.push(
                            state.push(constants.State.TrackingPendingEvents, events)
                        );

                        RSVP.all(promises).then(resolve, reject);
                    });
                })
                // get offer id
                .then(function () {
                    return state.get(constants.State.OrderOfferId);
                })
                .then(function (values) {
                    offerId = values && values[0];
                    offerId = Array.isArray(offerId)?offerId:[offerId];
                    offerId  = offerId.map(function (item) {
                        return item + '';
                    });

                    if (offerId == null || offerId.length <= 0) {
                        var err = new Error('No offer id is found');
                        return RSVP.reject(err);
                    }
                })
                // update next execution date
                .then(function () {
                    var order = orderInfo;
                    if (order.Items == null || order.Items.length <= 0) {
                        return RSVP.resolve();
                    }

                    var promises = [];
                    for (var l = order.Items.length; l--;) {
                        var tmp = order.Items[l];
                        var tmpOfferId = tmp.OfferId || tmp.Offer_id;
                        var nextExecutionDate = tmp.NextPhaseExecutionDate || tmp.NextExecutionDate;
                        if (
                            nextExecutionDate == null ||
                            (typeof offerId.indexOf === 'function' && offerId.indexOf(tmpOfferId + '') < 0)
                        ) {
                            continue;
                        }

                        promises.push(state.push('order.next_execution_date', nextExecutionDate));
                        if (tmp.PaymentType) {
                            promises.push(state.push('order.payment_type', tmp.PaymentType));
                        }
                    }

                    return RSVP.all(promises);
                })
                // delete member cache
                .then(function () {
                    memberCache.clear();
                });
        },

        getCurrentFlowType: function () {
            var types = [
                constants.CheckoutFlowType.Default, 
                constants.CheckoutFlowType.Return, 
                constants.CheckoutFlowType.Upsell, 
                constants.CheckoutFlowType.Redemption, 
                constants.CheckoutFlowType.WelcomeBack,
                constants.CheckoutFlowType.PaymentUpdate
            ];

            return RSVP.resolve()
                .then(function(){
                    var checkoutPathMatch = window.location.pathname.match(/^\/(\w\w-\w\w\w?\/)?buy\/(\w+(-\w+)*)\/.*/i);
                    var type = constants.CheckoutFlowType.Default;
                    if (checkoutPathMatch) {
                        var flowName = checkoutPathMatch[2];
                        if (flowName.toLowerCase().indexOf('return') === 0){
                            type = constants.CheckoutFlowType.Return;
                        }
                        else if (flowName.toLowerCase().indexOf('upsell') === 0){
                            type = constants.CheckoutFlowType.Upsell;
                        }
                        else if (flowName.toLowerCase().indexOf('redemption') === 0){
                            type = constants.CheckoutFlowType.Redemption;
                        }
                        else if (flowName.toLowerCase().indexOf('welcome-back') === 0){
                            type = constants.CheckoutFlowType.WelcomeBack;
                        }
                        else if (flowName.toLowerCase().indexOf('payment') === 0){
                            type = constants.CheckoutFlowType.PaymentUpdate;
                        }
                        return RSVP.resolve(type);
                    }
                    else {
                        return state.get(constants.State.TrackingCheckoutFlowTypeCustom)
                            .then(function(values){
                                var customValue = values[0];
                                if (customValue && types.indexOf(customValue) >= 0) {
                                    return customValue;
                                }
                                else {
                                    return constants.CheckoutFlowType.Default;
                                }
                            });
                    }
                    
                });
            
        }
    };
});
